import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styled from 'styled-components';
import styles from '../../../styles';
import * as navigationActions from '../../navigation/navigation.actions';
import { stripWPPath } from '../../../utils/stripWPPath';

import { LinkArrow } from './';

const StyledTextLink = styled.a`
  font-family: 'ApercuMono';
  text-transform: uppercase;
  font-size: 1rem;
  position: relative;
  
  ${styles.media.tablet`
    font-size: 1.5rem;
  `}
  
  ${styles.media.phone`
    font-size: 1rem;
  `}
  margin-bottom: 1em;

  color: ${styles.color.ORANGE};
  display: inline-flex;
  align-items: center;
  cursor: pointer;

  span {
    position: relative;
    transform: translate3d(0, 0, 0);
    transition-property: transform;
    transition-duration: .3s;
    transition-delay: 0s;
    transition-timing-function: ${styles.easing.outCubic};
    will-change: transform;
  }
  
  figure {
    transition-property: transform, opacity;
    transition-duration: .25s;
    transition-timing-function: ${styles.easing.outCubic};
    will-change: transform, opacity;
    
    &.normal {
      transition-delay: .175s;
    }
    &.focused {
      transition-delay: 0s;
      position: absolute;
      opacity: 0;
    }
  }

  &:not(.reverse) {
    figure {
      &.normal {
        margin-left: 1em;
      }
      &.focused {
        //left: 0;
        transform: translate3d(-1.5em, 0, 0);
      }
    }
  }

  &.reverse {
    figure {
      &.normal {
        margin-right: 1em;
      }
      &.focused {
        right: 0;
        transform: translate3d(1.5em, 0, 0);
      }
    }
  }
  
  &.hover {
    span {
      transition-delay: .075s;
    }
    figure {
      transition-timing-function: ${styles.easing.outCubic};
      &.normal {
        transition-delay: 0s;
        opacity: 0;
      }
      &.focused {
        transition-delay: .1s;
        opacity: 1;
        transform: translate3d(0, 0, 0);
      }
    }
    
    &:not(.reverse) {
      span {
        transform: translate3d(2.5em, 0, 0);
      }
      figure {
        &.normal {
          transform: translate3d(1.5em, 0, 0);
        }
      }
    }
    &.reverse {
      span {
        transform: translate3d(-2.5em, 0, 0);
      }
      figure {
        &.normal {
          transform: translate3d(-1.5em, 0, 0);
        }
      }

    }
  }

  &.arrowOnly {
    figure {
      &.normal {
        margin-left: 0;
      }
    }
  }
}
`;

class TextLink extends Component {
  state = {
    hover: false,
  };

  onMouseOver = () => {
    this.setState({
      hover: true,
    });
  };

  onMouseOut = () => {
    this.setState({
      hover: false,
    });
  };

  onClick = e => {
    const { to, navigate, onClick } = this.props;
    if (onClick) {
      onClick();
      return;
    }
    e.preventDefault();
    e.stopPropagation();

    const url = stripWPPath(to);
    const isExternal = url === to && url.indexOf('://') > -1;

    if (!isExternal) {
      navigate(url);
    } else {
      window.open(to);
    }
    return false;
  };

  render() {
    const { children, isMouseOver, reverse, disableClick } = this.props;
    const className = classnames({
      arrowOnly: !children,
    });
    const containerClassName = classnames(className, {
      hover: this.state.hover || isMouseOver,
      reverse: reverse,
    });
    const firstArrowClassName = !reverse ? 'focused' : 'normal';
    const secondArrowClassName = !reverse ? 'normal' : 'focused';
    return (
      <StyledTextLink
        className={containerClassName}
        onMouseEnter={this.onMouseOver}
        onMouseOver={this.onMouseOver}
        onMouseLeave={this.onMouseOut}
        onTouchStart={this.onMouseOver}
        onTouchEnd={this.onMouseOut}
        onClick={!disableClick ? this.onClick : undefined}
      >
        <LinkArrow className={firstArrowClassName} reverse={reverse} />
        <span>{children}</span>
        <LinkArrow className={secondArrowClassName} reverse={reverse} />
      </StyledTextLink>
    );
  }
}

TextLink.propTypes = {
  children: PropTypes.any,
  to: PropTypes.string,
  disableClick: PropTypes.bool,
  //  isExternal: PropTypes.bool,
  isMouseOver: PropTypes.bool,
  reverse: PropTypes.bool,
  navigate: PropTypes.func.isRequired,
  onClick: PropTypes.func,
};

export default connect(null, navigationActions)(TextLink);



// WEBPACK FOOTER //
// ./src/modules/pages/components/TextLink.js